import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';

import Contact from '../views/Contact.vue';
import Contract from '../views/Contract.vue';
import Home from '../views/Home.vue';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/KOL-contract',
    name: 'Contract',
    component: Contract,
  },
  {
    path: '/contact-us',
    name: 'Contact',
    component: Contact,
  },
];

const router = new VueRouter({
  mode: 'history',
  routes,
});

export default router;
